import React from "react";
import { theme } from "../../theme";

/**
 * Skeleton loader component for showing loading states
 * Provides a shimmer animation effect
 */
const SkeletonCard = ({ height = "200px", width = "100%", borderRadius = theme.borderRadius.lg }) => {
  return (
    <div
      style={{
        background: "linear-gradient(90deg, #1a2332 25%, #1e293b 50%, #1a2332 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        borderRadius: borderRadius,
        height: height,
        width: width,
        marginBottom: theme.spacing.lg,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export default SkeletonCard;
